import { useRouter } from "next/router";

import { API_BASE_URL } from "@/api/api.config";
import useLazyRestQuery from "@/remoteState/useLazyRestQuery";
import stringifyParams from "@/utils/stringifyParams";

const useLegacyWritePromptGet = (id, classroomIds = [], groupIds = []) => {
  const resource = `${API_BASE_URL}/api/v2/prompt/`;
  const params = { article_id: id };
  if (groupIds.length > 0) {
    params.group_ids = groupIds.join(",");
  } else if (classroomIds.length > 0) {
    // Add classroom id only when there are no group ids.
    // Because an assignment can be either group or a classroom assignment, but not both.
    params.classroom_ids = classroomIds.join(",");
  }

  const {
    query: { copiedAssignmentId },
  } = useRouter();
  if (copiedAssignmentId) {
    params.copied_assignment_id = copiedAssignmentId;
  }

  const requestUrl = `${resource}${stringifyParams(params)}`;

  return useLazyRestQuery(requestUrl, { skip: !id });
};

export default useLegacyWritePromptGet;
